/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: getters.ts
 * Class: getters.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { GetterTree } from 'vuex';
import { TextItem, TextState } from './types';
import { MutationRequestStatus, RootState } from '../types';

export const getters: GetterTree<TextState, RootState> = {
  news: (state) => state.news.data,
  success: (state) => state.news.status === MutationRequestStatus.SUCCESS,
  error: (state) => state.news.status === MutationRequestStatus.ERROR,
  loading: (state) => state.news.status === MutationRequestStatus.LOADING,
  newsNotFound: (state) => state.news.status === MutationRequestStatus.ERROR
    && state.news.error.code === 404,
};
